import { isAxiosError } from 'axios'
import { LoginStrategy } from './types'

type SSORequiredError = {
  error: 'SSORequiredError'
  msg: string
  strategies: LoginStrategy[]
}

type MFARequiredError = {
  error: 'MFARequiredForTenant'
  msg: string
}

type SessionUnauthenticatedError = {
  error: 'SessionUnauthenticated'
  msg: string
}

export type LoginErrors = SSORequiredError | MFARequiredError | SessionUnauthenticatedError

export type GenericError = {
  error: string
  msg: string
}

/**
 * Error code returned (with a 400) when a deskless member has no email on their
 * record and must provide a rewards email before accessing/redeeming rewards.
 * Primarily thrown by `GET /rewards/rewardProviders/my`, but may be thrown by
 * other reward endpoints too. See epic SYN-7280.
 */
export const REWARD_EMAIL_REQUIRED = 'RewardEmailRequired'

export type RewardEmailRequiredError = {
  error: typeof REWARD_EMAIL_REQUIRED
  msg: string
}

/**
 * Type guard for the `RewardEmailRequired` API error (see {@link REWARD_EMAIL_REQUIRED}).
 * Use this everywhere the error needs to be detected — e.g. to know that a
 * reward query failed only because the member has no email yet, so its cache
 * should be reset/refetched once an email is captured rather than treated as a
 * genuine "not found".
 */
export const isRewardEmailRequiredError = (error: unknown): boolean =>
  isAxiosError(error) &&
  (error.response?.data as { error?: string } | undefined)?.error === REWARD_EMAIL_REQUIRED
